function hasES6() {
  return window.Promise && String.prototype.endsWith;
}

module.exports = function loadPolyfills(callback) {
  if (!hasES6()) {
    require('core-js/es6'); // eslint-disable-line global-require
  }
  if (!window.Promise.prototype.finally) {
    require('core-js/modules/es7.promise.finally'); // eslint-disable-line global-require
  }

  callback();
};



// WEBPACK FOOTER //
// ./static/js/v0/load-polyfills.js